import { TableCellWithBadge } from "../../../data-model/tableCells";
import { NycbsExternalLogsStageRow } from "../../../pages/nycbsExternal/types/nycbsExternalLogsModalData";
import { TableCellType, TableHeader } from "../../custom-table/table";

export enum NycbsExternalLogsTableColumnKeys {
  STAGE = "stage",
  FILENAME = "filename",
  CMM_KEY = "cmmKey",
  OUTCOME = "outcome",
}

export const nycbsExternalLogsTableHeaders: TableHeader[] = [
  {
    label: "Stage",
    key: NycbsExternalLogsTableColumnKeys.STAGE,
    order: 1,
    width: 18,
    sortable: false,
    type: TableCellType.STRING,
  },
  {
    label: "Filename",
    key: NycbsExternalLogsTableColumnKeys.FILENAME,
    order: 2,
    width: 48,
    sortable: false,
    type: TableCellType.STRING,
  },
  {
    label: "Key",
    key: NycbsExternalLogsTableColumnKeys.CMM_KEY,
    order: 3,
    width: 16,
    sortable: false,
    type: TableCellType.STRING,
  },
  {
    label: "Outcome",
    key: NycbsExternalLogsTableColumnKeys.OUTCOME,
    order: 4,
    width: 18,
    sortable: false,
    type: TableCellType.BADGE,
  },
];

/**
 * Maps Logs modal stage rows into CustomTable row data.
 *
 * @input stages - Stage rows built from the selected order
 * @return Record[]: Rows formatted for CustomTable
 */
export const generateNycbsExternalLogsTableData = (
  stages: NycbsExternalLogsStageRow[],
): Record<string, string | TableCellWithBadge>[] => {
  return stages.map((stage) => {
    const outcome: TableCellWithBadge = {
      text: stage.outcomeText,
      color: stage.outcomeColor,
      bgColor: stage.outcomeBgColor,
      hoverText: stage.outcomeText,
    };

    return {
      stage: stage.stage,
      filename: stage.filename,
      cmmKey: stage.cmmKey,
      outcome,
    };
  });
};
